import React, { useMemo } from 'react';
import Icon from '../Icon';
import { ToastModel } from '../../Types/Toast';
import clsx from 'clsx';

const Toast = ({ title, text, type = 'default' }: ToastModel) => {
  const iconName = useMemo(() => {
    switch (type) {
      case 'default':
      case 'info':
      default:
        return 'info';
      case 'success':
        return 'check-circle';
      case 'error':
      case 'warning':
        return 'warning';
    }
  }, [type]);

  const backgroundColor = useMemo(() => {
    switch (type) {
      case 'default':
      default:
        return 'bg-white';
      case 'info':
        return 'bg-primary-50';
      case 'success':
        return 'bg-success-50';
      case 'error':
        return 'bg-error-50';
      case 'warning':
        return 'bg-warning-50';
    }
  }, [type]);

  const iconColor = useMemo(() => {
    switch (type) {
      case 'default':
      default:
        return 'text-gray-900';
      case 'info':
        return 'text-primary-500';
      case 'success':
        return 'text-success-500';
      case 'error':
        return 'text-error-500';
      case 'warning':
        return 'text-warning-500';
    }
  }, [type]);

  return (
    <div className={clsx('grid  grid-cols-8 gap-2 p-3', backgroundColor)}>
      <div className="col-span-1 flex items-start justify-center">
        <Icon name={iconName} className={clsx(iconColor, 'h-5 w-5')} />
      </div>
      <div className="col-span-7">
        {title && (
          <div className="mb-2 text-md font-bold text-gray-900">
            {title}
          </div>
        )}
        {text && (
          <div className="text-md font-light text-gray-600">{text}</div>
        )}
      </div>
    </div>
  );
};

export default Toast;
